import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const EmptyAddressBook = ({ className }) => (
  <div className={className}>
    No addresses added yet. Use ADD NEW ADDRESS above to create a new one.
  </div>
)

EmptyAddressBook.defaultProps = {
  className: '',
}

EmptyAddressBook.propTypes = {
  className: PropTypes.string,
}

const StyledEmptyAddressBook = styled(EmptyAddressBook)({
  lineHeight: '30px',
  textAlign: 'center',
})

export default StyledEmptyAddressBook
